import React from 'react';
import { Outlet } from 'react-router-dom';
import '../App.css';
import Dash from './Dash';

const LayoutWithDash = () => {
  return (
    <div className="layout-wrapper">
      <div className="dash-container">
        <Dash />
      </div>
      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
};

export default LayoutWithDash;